import React, { useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_OFFSETS_BY_PAGINATION } from 'api';
import { SearchIcon } from 'tt-ui-lib/icons';
import { Input, HelpTooltip, DatePicker } from 'tt-ui-lib/core';
import { useNavigate } from 'react-router-dom';
import styles from '../../Decarbonizator.module.scss';
import OffsetsTabContent from './OffsetsTabContent';
import moment from 'moment';

const { REACT_APP_MARKET } = process.env;

const OffsetsTab = () => {
  const navigate = useNavigate();

  const [getOffsetsList] = useLazyQuery(GET_OFFSETS_BY_PAGINATION, {
    fetchPolicy: 'network-only',
  });
  const [offsets, setOffsets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginatorInfo, setPaginatorInfo] = useState({});
  const [searchString, setSearchString] = useState('');
  const [timeoutID, setTimeoutID] = React.useState(null);
  const [datePickerValue, setDatePickerValue] = React.useState('');
  const [queryFilter, setQueryFilter] = useState({
    page: 1,
    first: 4,
    input: {
      ordersBy: [
        {
          column: 'created_at',
          direction: 'DESC',
        },
      ],
    },
  });

  const getTableData = async () => {
    setLoading(true);
    const response = await getOffsetsList({
      variables: queryFilter,
      fetchPolicy: 'network-only',
    });
    if (
      response &&
      response.data &&
      response.data.getAllOffsetsWithPagination &&
      response.data.getAllOffsetsWithPagination.data
    ) {
      setOffsets(response.data.getAllOffsetsWithPagination.data);
      setPaginatorInfo(response.data.getAllOffsetsWithPagination.paginatorInfo);
    }
    setLoading(false);
  };

  const onAssetsRowClick = (row) => {
    navigate(`/dashboard/decarbonizator/certificate/${row.id}`);
  };

  const searchByDate = (value) => {
    setDatePickerValue(value);
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
    const timeout = setTimeout(() => {
      setQueryFilter((current) => ({
        ...current,
        input: {
          ...current.input,
          dateFilter: value !== null ? moment(value?.$d).format('YYYY-MM-DD') : null,
        },
      }));
    }, 1000);
    setTimeoutID(timeout);
  };

  const searchById = (value) => {
    setSearchString(value);
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
    const timeout = setTimeout(() => {
      setQueryFilter((current) => ({
        ...current,
        input: { ...current.input, partial_id: value },
      }));
    }, 2000);
    setTimeoutID(timeout);
  };

  const changePage = (value) => {
    setQueryFilter((current) => ({ ...current, page: value }));
  };

  useEffect(() => {
    (async () => {
      await getTableData();
    })();
  }, [queryFilter]);
  return (
    <div className={styles.caffeeTab}>
      <div className={styles.filters}>
        <Input
          placeholder="Search by Certificate ID"
          className={styles.searchFilter}
          prefix={<SearchIcon style={{ width: 20, height: 20 }} />}
          value={searchString}
          onChange={(e) => searchById(e.target.value)}
        />

        <DatePicker
          className={styles.topSelect}
          label="Date"
          format="YYYY-MM-DD"
          value={datePickerValue}
          onChange={(newValue) => {
            searchByDate(newValue);
          }}
        />
      </div>

      {offsets.length > 0 || loading ? (
        <>
          <OffsetsTabContent
            changePage={changePage}
            paginatorInfo={paginatorInfo}
            data={offsets}
            onRowClick={onAssetsRowClick}
            isLoading={loading}
            description="All your tokenized carbon offset certificates are stored here. Each certificate is a Soulbound Token (SBT), a personalized, non-transferable digital asset issued in your name representing your contribution to the global decarbonization effort. Move asset to your wallet, build a collection of SBTs and monetize your environmental impact with a unique sustainable NFT."
          />
        </>
      ) : (
        <div className={styles.container}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span className={`${styles.h1} ${styles.header}`} style={{ marginBottom: 0 }}>
              Offsets
            </span>
            <HelpTooltip tooltipText="All your tokenized carbon offset certificates are stored here. Each certificate is a Soulbound Token (SBT), a personalized, non-transferable digital asset issued in your name representing your contribution to the global decarbonization effort. Move asset to your wallet, build a collection of SBTs and monetize your environmental impact with a unique sustainable NFT." />
          </div>

          <div className={styles.emptyDesc}>
            Find all your digitized carbon credits and certificates here. <br /> Ready to start?
            Visit our{' '}
            <a href={`${REACT_APP_MARKET}/dashboard/marketplace/list/product?activeTab=carbon`}>
              Carbon Credit Marketplace
            </a>{' '}
            to purchase credits.
          </div>
        </div>
      )}
    </div>
  );
};

export default OffsetsTab;
